// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPanel_container__OX9DL","select":"OrderPanel_select__gRpJC","lblSelect":"OrderPanel_lblSelect__BdgUO"};